import { useWindowSize } from "usehooks-ts";
import { breakPoints } from "constants/ResponsiveDesignBreakPoints";

type Props = {
  color?: string;
  size?: "MOBILE" | "TABLET" | "LARGE";
  onClick?: any;
  sameSize?: boolean;
};
function PencilIcon({ color, size, onClick,sameSize }: Props) {
  const { width } = useWindowSize();

  return (
    <svg
    onClick={onClick}
    width={window.innerWidth < breakPoints.md - 1 && !sameSize ?  "15":  "24"}
    height={window.innerWidth < breakPoints.md - 1 && !sameSize ?  "15":  "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2599 3.59924L5.04985 12.2892C4.73985 12.6192 4.43985 13.2692 4.37985 13.7192L4.00985 16.9592C3.87985 18.1292 4.71985 18.9292 5.87985 18.7292L9.09985 18.1792C9.54985 18.0992 10.1799 17.7692 10.4899 17.4292L18.6999 8.73924C20.1199 7.23924 20.7599 5.52924 18.5499 3.43924C16.3499 1.36924 14.6799 2.09924 13.2599 3.59924Z"
        stroke={color ? color : "#858D98"}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8901 5.05078C12.3201 7.81078 14.5601 9.92078 17.3401 10.2008"
        stroke={color ? color : "#858D98"}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 22H21"
        stroke={color ? color : "#858D98"}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default PencilIcon;

// fill={white ? "#fffff" : "#0F1322"}
